/**
* Web Service handler to retrieve existing appointments for a Consumer
*
* @class SearchWS
*/
var SearchWS = function (parent) {
  var self = this; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self.customProps = ko.observableArray([]);
  self.name = 'SearchWS';				// Convenience name for debugging
  self.foundAppointments = ko.observableArray([]);	// Collection of appointments for the
  // time specified
  self.returnedResultCount = ko.observable(null);


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/appointments/search';
  });


	/**
	* Looks through foundAppointments and allows for filtering of results in
	* search results list.
	*
	* @method appointments
	* @return {Array} Collection of AppointmentModels
	*/
  self.appointments = ko.computed(function () {
    // Loop over all appointments returned from the search.
    return self.foundAppointments().reduce(function (arr, appt) {
      var cProps = $(appt).find('customProp'),
        loc = null,
        useAppt = appt,
        q = qcal.queuesWS.indexedQueues()[useAppt.queueId]; // Obtain a copy of a QueueModel

      // If a QueueModel was found, use it's description for display
      if (q) {
        useAppt.queueName(q.description);
        useAppt.phoneDigitCount(q.privatePhoneDigitCount);
      }

      if (appt.customPropsFirst != null) {
        if ($.inArray(appt.customPropsFirst.name, self.customProps()) == -1) {
          self.customProps.push(appt.customPropsFirst.name);
        }
      }

      appt.customProps.forEach(function (prop) {
        if ($.inArray(prop.name, self.customProps()) == -1) {
          self.customProps.push(prop.name);
        }
      });

      loc = qcal.locationsWS.getLocationByQueueId(useAppt.queueId);
      useAppt.locationName = loc.name;

      arr.push(useAppt);

      return arr;
    }, []);
  });


	/**
	* This method overrides the AbstractWS method of the same name and ensures
	* that there is a query to pass, and then sets up the parameters before
	* calling the superclass method.
	*
	* @method doRequest
	* @param {Function} fCallback
	* @return {SearchWS}
	*/
  self.doRequest = function (fCallback) {
    self.parent.toggleOpenAvailability(false);

    if (qcal.searchFor() != null && qcal.queuesWS.allQueueIds().length > 0) {
      self.clearParams();
      self.foundAppointments.removeAll();
      self.returnedResultCount(null);

      self.addParam('queueIds', qcal.queuesWS.allQueueIds().join(','));
      self.addParam('query', $.trim(qcal.searchFor()));

      self.addParam('past', ((qcal.searchPast()) ? true : false));

      qcal.setStatusMessage('Searching for FlexAppointments');

      AbstractWS.prototype.doRequest.call(self);
    }

    // Return self (SearchWS) to be chainable, for best practice
    return self;
  };


	/**
	* Generates a string indicating how many search results were found
	*
	* @method resultsCountMessage
	* @return {String}
	*/
  self.resultsCountMessage = ko.computed(function () {
    if (self.returnedResultCount() == null) {
      return;
    }
    else {
      return self.returnedResultCount() + ' ' + ((self.returnedResultCount() == 1) ? qcal.messagesWS.get('appointment') : qcal.messagesWS.get('appointments')) + ' ' + qcal.messagesWS.get('found');
    }
  });


	/**
	* This method iterates over the data returned from the service and
	* converts the individual nodes into AppointmentModels and then assigns
	* them to this object's appointments collection.
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @return {SearchWS} Returns the object as chainable, for best practice
	*/
  self.processData = function (xmlData) {
    var appts = [],					// A collection of jQuery matched nodes
      json = xmlToJson.parse(xmlData),
      aTemp = [];					// Temporary array to stack appointments in to
    // This allows events bound to the collection
    // to be fired once instead of multiple times

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Clear out any existing appointment blocks
    self.foundAppointments.removeAll();

    // Make sure appointments are in an array
    appts = (Array.isArray(json.appointments.appointment)) ? json.appointments.appointment : (json.appointments.appointment) ? [json.appointments.appointment] : [];

    // Loop over each appointment, turning it into an AppointmentModel
    appts.forEach(function (a) {
      aTemp.push(new AppointmentModel(a));
    });

    // Set the appointments collection to the temporary collection of appointments
    self.foundAppointments(aTemp);

    // Set an observable that the UI can use to display a message to the user to
    // let them know how many results were found.

    self.returnedResultCount(aTemp.length);

    // If one or more appointments were found, move the calendar forward to that date
    // and then request appointments to be displayed
    if (aTemp.length > 0) {
      qcal.globalViewType('searchResults');
    }

    qcal.clearStatusMessage();

    // Return self (SearchWS) to be chainable, for best practice
    return self;
  };


	/**
	* Method to reset the search object
	*
	* @method reset
	* @return {SearchWS} Returns the object as chainable, for best practice
	*/
  self.reset = function () {
    self.clearParams();
    self.foundAppointments.removeAll();
    self.returnedResultCount(null);
    self.parent.searchFor(null);

    // Return self (SearchWS) to be chainable, for best practice
    return self;
  };


	/**
	* Sets an appointment's status in the collection of appointments
	*
	* @method setAppointmentStatus
	* @param {Integer} iAppointmentId ID of the appointment to manipulate
	* @param {String} sStatus Updated status
	* @return {SearchWS} Returns the object as chainable, for best practice
	*/
  self.setAppointmentStatus = function (iAppointmentId, sStatus) {
    self.appointments().forEach(function (appt) {
      if (appt.id == parseInt(iAppointmentId)) {
        appt.settingManualStatus = true;
        appt.status(sStatus);
      }
    });

    // Return self (SearchWS) to be chainable, for best practice
    return self;
  };

  return self;
};

SearchWS.prototype = AbstractWS.prototype;
SearchWS.prototype.constructor = SearchWS;
